{
  "settings": "Asetukset",
  "yourDigitalAssistant": " Digitaalinen avustajasi",
  "getStarted": "Aloita",
  "login": "Kirjaudu",
  "loggingIn": "Kirjautuu sisään ...",
  "darkMode": "Tumma tila",
  "clearHistory": "Tyhjennä historia",
  "historyCleared": "Historia tyhjennetty",
  "changeLanguage": "Kieli",
  "termsAndConditions": "Käyttöehdot",
  "messagePlaceholder": "Kirjoita viestisi tähän ...",
  "messagePlaceholderDisabled": "Kirjoitus pois käytöstä ...",
  "feedbackTitle": "Arvioi kokemuksesi",
  "feedbackPlaceholder": "Kerro meille siitä (valinnainen)",
  "feedbackSend": "Lähetä",
  "feedbackClose": "Sulje",
  "sessionExpired": "Istuntosi on vanhentunut.",
  "startNewSession": "Aloita uusi istunto",
  "apiError": "Hups! Jokin meni pieleen. Korjaamme asian mahdollisimman pikaisesti.",
  "apiErrorOffline": "Et ole yhdistettynä internetiin.",
  "tryAgain": "Yritä uudestaan",
  "startOver": "Aloita alusta",
  "chatEnded": "Chat on päättynyt.",
  "chatEndedThankYou": "Kiitos keskustelusta kanssamme!",
  "closeChat": "Sulje",
  "startNewChat": "Keskustele uudelleen",
  "humanTakeoverStarted": "Sinut yhdistetään asiakaspalveluun ...",
  "humanTakeoverQueued": "Odotetaan palveluneuvojalle yhdistämistä",
  "humanTakeoverAnAgent": "Palveluneuvoja",
  "humanTakeoverAgentEntered": "liittyi keskusteluun",
  "humanTakeoverAgentLogout": "lähti keskustelusta",
  "humanTakeoverTransfer": "Sinut yhdistetään uudelle palveluneuvojalle",
  "humanTakeoverEnded": "Keskustelet nyt digitaalisen avustajan kanssa",
  "version": "Versio",
  "formIntroText": "Ole hyvä ja täytä lomake aloittaaksesi keskustelun kanssamme.",
  "formFirstName": "Etunimi",
  "formLastName": "Sukunimi",
  "formName": "Nimi",
  "formEmail": "Sähköposti",
  "formWrongEmail": "Anna voimassaoleva sähköpostiosoite",
  "formPhone": "Puhelin",
  "formShipmentId": "Seurantanumero",
  "formQuestion": "Kysymyksesi",
  "formAccountNumber": "Tilinumero (yritysasiakkaille)",
  "formAddress": "Osoite",
  "formPostcode": "Postinumero",
  "formCity": "Kaupunki",
  "formCountry": "Maa",
  "formSubmitButton": "Aloita keskustelu",
  "formEmptyFieldError": "Pakollinen kenttä",
  "formPhoneNumberValidationError": "Puhelinnumero on virheellinen.",
  "formInputIsBiggerThan50": "Enintään 50 merkkiä.",
  "formInputIsBiggerThan100": "Enintään 100 merkkiä.",
  "formInputIsBiggerThan2000": "Enintään 2000 merkkiä.",
  "widgetEventOnline": "Digitaalisen avustajan viesti: Käyttäjä on taas paikalla.",
  "widgetEventHidden": " Digitaalisen avustajan viesti: Widget on piilotettu.",
  "widgetEventVisible": " Digitaalisen avustajan viesti: Widget on näkyvillä.",
  "widgetEventVisibleMinimized": " Digitaalisen avustajan viesti: Widget on näkyvillä mutta pienennetty.",
  "widgetEventMinimized": " Digitaalisen avustajan viesti: Widget on pienennetty.",
  "widgetEventMaximized": " Digitaalisen avustajan viesti: Widget on suurennettu.",
  "widgetEventSessionExpired": "Digitaalisen avustajan viesti: Widgetin istunto on vanhentunut.",
  "widgetEventHangupHuman": "DA -viesti: Käyttäjä lopettaa ihmisen valtaistunnon.",
  "widgetEventUserTyping": "Digitaalisen avustajan viesti: Käyttäjä kirjoittaa.",
  "fileTooLarge": "Yrität liittää liian isoja tiedostoja.",
  "tooManyDiles": "Yrität liittää liian monta tiedostoa.",
  "fileInvalidType": "Yrität liittää virheellisiä tiedostotyyppejä.",
  "attachmentsDropHere": "Pudota tähän ladataksesi tai",
  "attachmentsBrowse": "Selaa tiedostoja",
  "attachmentsExtenstionQuantity": "pdf tai kuvat (enintään 10 tiedostoa)",
  "attachmentsSize": "enintään 30 Mt.",
  "attachmentsFailedUploading": "Lataus epäonnistui",
  "attachmentsUploading": "Lähetetään ...",
  "minimizeExpandText": "Live-chat kanssamme nyt!",
  "popupWidgetNotificationMessage": "Sait uuden viestin!",
  "tabWidgetNotificationMessage": "Uusi viesti!",
  "datepickerSendButton": "Lähetetty"
}
